(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["aig-atlas-article"]) return;
  try {
    
document.querySelectorAll('[data-atlas-player]').forEach((player) => {
  const button = player.querySelector('[data-atlas-fullscreen]');
  let previousOverflow;
  const expanded = () => document.fullscreenElement === player || player.classList.contains('is-expanded');
  const sync = () => {
    button.textContent = expanded() ? 'Exit fullscreen' : 'Enter fullscreen';
    button.setAttribute('aria-pressed', String(expanded()));
  };
  const fallback = (open) => {
    player.classList.toggle('is-expanded', open);
    if (open) { previousOverflow = document.body.style.overflow; document.body.style.overflow = 'hidden'; }
    else { document.body.style.overflow = previousOverflow || ''; button.focus(); }
    sync();
  };
  button.addEventListener('click', async () => {
    if (document.fullscreenElement === player) { await document.exitFullscreen(); }
    else if (player.classList.contains('is-expanded')) { fallback(false); }
    else if (player.requestFullscreen && document.fullscreenEnabled) {
      try { await player.requestFullscreen(); } catch { fallback(true); }
    } else { fallback(true); }
  });
  player.closest('.journal-wrap').querySelector('[data-atlas-launch]').addEventListener('click', (event) => { event.preventDefault(); if (!expanded()) button.click(); });
  document.addEventListener('fullscreenchange', sync);
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && player.classList.contains('is-expanded')) fallback(false);
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["aig-dead-article"]) return;
  try {
    
document.querySelectorAll('[data-dead-player]').forEach((player) => {
  const button = player.querySelector('[data-dead-fullscreen]');
  let previousOverflow;
  const expanded = () => document.fullscreenElement === player || player.classList.contains('is-expanded');
  const sync = () => {
    button.textContent = expanded() ? 'Exit fullscreen' : 'Enter fullscreen';
    button.setAttribute('aria-pressed', String(expanded()));
  };
  const fallback = (open) => {
    player.classList.toggle('is-expanded', open);
    if (open) { previousOverflow = document.body.style.overflow; document.body.style.overflow = 'hidden'; }
    else { document.body.style.overflow = previousOverflow || ''; button.focus(); }
    sync();
  };
  button.addEventListener('click', async () => {
    if (document.fullscreenElement === player) { await document.exitFullscreen(); }
    else if (player.classList.contains('is-expanded')) { fallback(false); }
    else if (player.requestFullscreen && document.fullscreenEnabled) {
      try { await player.requestFullscreen(); } catch { fallback(true); }
    } else { fallback(true); }
  });
  player.closest('.journal-wrap').querySelector('[data-dead-launch]').addEventListener('click', (event) => { event.preventDefault(); if (!expanded()) button.click(); });
  window.addEventListener('message', event => { if(event.source !== player.querySelector('iframe').contentWindow) return; if(event.data?.type === 'dead-atlas-fullscreen') button.click(); if(event.data?.type === 'dead-atlas-exit-fullscreen' && expanded()) button.click(); });
  document.addEventListener('fullscreenchange', sync);
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && player.classList.contains('is-expanded')) fallback(false);
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["aig-home-allen"] && !Shopify.designMode) return;
  try {
    

if (!customElements.get('aig-featured-hero')) {
  customElements.define('aig-featured-hero', class extends HTMLElement {
    connectedCallback() {
      this.slides = Array.from(this.querySelectorAll('.aig-featured-hero__slide'));
      this.index = 0;
      this.timer = null;
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.paused = this.dataset.autoplay !== 'true' || this.motion.matches;
      this.visible = true;
      this.engaged = false;
      const engage = () => { this.engaged = true; this.sync(); };
      document.addEventListener('scroll', engage, { ...options, once: true, passive: true });
      document.addEventListener('pointerdown', engage, { ...options, once: true, passive: true });
      document.addEventListener('keydown', engage, { ...options, once: true });
      this.hovered = false;
      this.focused = false;
      this.controls = this.querySelector('.aig-featured-hero__controls');
      this.dots = this.slides.map((slide, index) => {
        const button = document.createElement('button');
        button.type = 'button';
        button.setAttribute('aria-label', (index + 1) + ' / ' + this.slides.length + ': ' + slide.getAttribute('aria-label'));
        button.addEventListener('click', () => { this.index = index; this.render(true); this.sync(); }, options);
        this.controls.append(button);
        return button;
      });
      if (!this.slides.length) return;
      this.render(false);
      this.classList.add('is-ready');
      if (this.slides.length < 2) return;
      this.controls.hidden = false;
      const surface = this.querySelector('.aig-featured-hero__slides');
      let startX = 0;
      let startY = 0;
      let suppressClick = false;
      const begin = (x, y) => {
        startX = x;
        startY = y;
        suppressClick = false;
        this.paused = true;
        this.querySelectorAll('source[data-srcset]').forEach(source => {
          source.srcset = source.dataset.srcset;
          delete source.dataset.srcset;
        });
        this.sync();
      };
      surface.addEventListener('touchstart', event => {
        if (event.touches.length === 1) begin(event.touches[0].clientX, event.touches[0].clientY);
      }, { ...options, passive: true });
      surface.addEventListener('touchmove', event => {
        if (event.touches.length !== 1) return;
        const dx = Math.abs(event.touches[0].clientX - startX);
        const dy = Math.abs(event.touches[0].clientY - startY);
        if (dx > 10 && dx > dy) suppressClick = true;
      }, { ...options, passive: true });
      surface.addEventListener('pointerdown', event => begin(event.clientX, event.clientY), options);
      surface.addEventListener('click', event => {
        if (!suppressClick) return;
        event.preventDefault();
        event.stopPropagation();
      }, { ...options, capture: true });
      surface.addEventListener('scroll', () => {
        if (!surface.clientWidth) return;
        const index = Math.max(0, Math.min(this.slides.length - 1, Math.round(surface.scrollLeft / surface.clientWidth)));
        if (index === this.index) return;
        this.index = index;
        this.updateState(true);
      }, { ...options, passive: true });
      surface.addEventListener('dragstart', event => event.preventDefault(), options);
      this.resizeObserver = new ResizeObserver(() => {
        surface.scrollTo({ left: this.index * surface.clientWidth, behavior: 'instant' });
      });
      this.resizeObserver.observe(surface);

      this.addEventListener('mouseenter', () => { this.hovered = true; this.sync(); }, options);
      this.addEventListener('mouseleave', () => { this.hovered = false; this.sync(); }, options);
      this.addEventListener('focusin', () => { this.focused = true; this.sync(); }, options);
      this.addEventListener('focusout', () => queueMicrotask(() => { this.focused = this.contains(document.activeElement); this.sync(); }), options);
      document.addEventListener('visibilitychange', () => this.sync(), options);
      this.motion.addEventListener('change', () => { if (this.motion.matches) this.paused = true; this.sync(); }, options);
      this.observer = new IntersectionObserver(entries => { this.visible = entries[0].isIntersecting; this.sync(); });
      this.observer.observe(this);
      this.sync();
    }
    render(announce) {
      const surface = this.querySelector('.aig-featured-hero__slides');
      surface.scrollTo({ left: this.index * surface.clientWidth, behavior: announce && !this.motion.matches ? 'smooth' : 'instant' });
      this.updateState(announce);
    }
    updateState(announce) {
      this.slides.forEach((slide, i) => {
        if (i === this.index) {
          const source = slide.querySelector('source[data-srcset]');
          if (source) {
            source.srcset = source.dataset.srcset;
            delete source.dataset.srcset;
          }
        }
        slide.hidden = false;
        slide.inert = false;
        slide.classList.toggle('is-active', i === this.index);
        slide.setAttribute('aria-hidden', 'false');
        slide.tabIndex = i === this.index ? 0 : -1;
      });
      this.dots.forEach((dot, i) => dot.setAttribute('aria-pressed', String(i === this.index)));
      if (announce) this.querySelector('[role="status"]').textContent = `${this.index + 1} / ${this.slides.length}: ${this.slides[this.index].getAttribute('aria-label')}`;
    }
    move(direction, manual) {
      if (manual) this.paused = true;
      this.index = (this.index + direction + this.slides.length) % this.slides.length;
      this.render(manual);
      this.sync();
    }
    sync() {
      window.clearInterval(this.timer);
      if (this.slides.length < 2) return;
      if (this.engaged && !this.paused && !this.dragging && !this.hovered && !this.focused && this.visible && !document.hidden) {
        this.timer = window.setInterval(() => this.move(1, false), Math.max(1000, Number(this.dataset.interval) || 4000));
      }
    }
    disconnectedCallback() {
      window.clearInterval(this.timer);
      this.abort?.abort();
      this.observer?.disconnect();
      this.resizeObserver?.disconnect();
    }
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["aig-phish-article"]) return;
  try {
    
document.querySelectorAll('[data-phish-player]').forEach((player) => {
  const button = player.querySelector('[data-phish-fullscreen]');
  let previousOverflow;
  const expanded = () => document.fullscreenElement === player || player.classList.contains('is-expanded');
  const sync = () => {
    button.textContent = expanded() ? 'Exit fullscreen' : 'Enter fullscreen';
    button.setAttribute('aria-pressed', String(expanded()));
    player.querySelector('iframe').contentWindow?.postMessage({type:'phish-atlas:fullscreen-state',open:expanded()}, '*');
  };
  const fallback = (open) => {
    player.classList.toggle('is-expanded', open);
    if (open) { previousOverflow = document.body.style.overflow; document.body.style.overflow = 'hidden'; }
    else { document.body.style.overflow = previousOverflow || ''; button.focus(); }
    sync();
  };
  button.addEventListener('click', async () => {
    if (document.fullscreenElement === player) { await document.exitFullscreen(); }
    else if (player.classList.contains('is-expanded')) { fallback(false); }
    else if (player.requestFullscreen && document.fullscreenEnabled) {
      try { await player.requestFullscreen(); } catch { fallback(true); }
    } else { fallback(true); }
  });
  player.closest('.journal-wrap').querySelector('[data-phish-launch]').addEventListener('click', (event) => { event.preventDefault(); if (!expanded()) button.click(); });
  window.addEventListener('message', (event) => {
    if (event.source !== player.querySelector('iframe').contentWindow) return;
    if (event.data?.type === 'phish-atlas:fullscreen') button.click();
    if (event.data?.type === 'phish-atlas:exit-fullscreen' && player.classList.contains('is-expanded')) fallback(false);
  });
  document.addEventListener('fullscreenchange', sync);
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && player.classList.contains('is-expanded')) fallback(false);
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
